<template>
  <div class="fixed-bg">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4">
        <!-- Slider -->
        <div id="slider">
          <!-- <h1>
            TRADEBOOK
          </h1> -->
        </div>
        <!-- Slider -->
      </div>
      <div class="col-md-8 light-bg">
        <h1>Research, Monitor, and Act on Municipal Bonds with Confidence</h1>
        <div class="loginWrap option">
          <img src="../../assets/img/brand/logoBlack.svg" alt="DRL" />
          <div class="d-flex">
            <div>
            <div class="head-text" v-if="userOrganization && userOrganization.length > 1">DRL</div> 
            <div class="row" v-if="(isBrokerDealer || isGuest || isRep || isAdmin || isEditor  || isTrader || isRiskManager || isSuperAdmin || isOperator || isCapitalRiskManager )">
              <div class="opn-wrap"  v-if="isAdmin || isEditor || isTrader || isSuperAdmin">
               <router-link to="/traderecap/dashboard">
               <span><img src="../../assets/img/brand/trade.png" alt="Trade Recap"></span>TRADE RECAP
                <button type="submit" class="btn btn-primary my-2" >GO
                  <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                </button>
              </router-link>
              </div>
              <div class="opn-wrap"  v-if="isAdmin || isEditor || isTrader || isSuperAdmin" >
                <router-link :to="{path : getBestRouteForBidSide()}">
                  <span><i class="fas fa-gavel"></i></span> BID SIDE
                    <button type="submit" class="btn btn-primary my-2" >GO
                      <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                    </button>
                </router-link>
              </div>
              <div class="opn-wrap"  v-if="isAdmin || isEditor || isTrader || isSuperAdmin" >
                <router-link :to="{path : getBestRouteForIms()}"  >
                  <span><i class="fas fa-hand-holding-usd"></i></span> IMS
                    <button type="submit" class="btn btn-primary my-2" >GO
                      <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                    </button>
                </router-link>

              </div>
              <div class="opn-wrap" v-if="isAdmin || isEditor || isTrader">
                <router-link to="/reports/moneylinelist">
                  <span><i class="fas fa-dollar-sign"></i></span> REPORTS
                    <button type="submit" class="btn btn-primary my-2" >GO
                      <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                    </button>
                </router-link>
              </div>
              <div class="opn-wrap" v-if="isCapitalRiskManager || isOperator || isTrader || isAdmin || isEditor || isBrokerDealer || isRiskManager || isSuperAdmin" >
                <router-link :to="{path : getBestRouteForAutobidder()}"   >
                  <span><i class="fas fa-bolt"></i></span> AUTO BIDDER
                    <button type="submit" class="btn btn-primary my-2" >GO
                      <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                    </button>
                </router-link>
              </div>
              <div class="opn-wrap" v-if="isOperator || isTrader || isAdmin">
                <router-link to="/bidaccumulator/dashboard"  >
                  <span><i class="fas fa-database"></i></span> BID ACCUMULATOR
                    <button type="submit" class="btn btn-primary my-2" >GO
                      <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                    </button>
                </router-link>
              </div>
              <div class="opn-wrap" v-if="!isGuest && (isOperator || isTrader || isAdmin || isEditor) ">
                <router-link to="/ticketsystem/importdata"  >
                  <span><i class="fas fa-folder-open"></i></span> TICKETING CATALOGUE
                    <button type="submit" class="btn btn-primary my-2" >GO
                      <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                    </button>
                </router-link>
              </div>
               <div class="opn-wrap" v-if="isGuest">
                <router-link to="/ticketsystem/processed"  >
                  <span><i class="fas fa-folder-open"></i></span> TICKETING CATALOGUE
                    <button type="submit" class="btn btn-primary my-2" >GO
                      <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                    </button>
                </router-link>
              </div>
              <div class="opn-wrap" v-if="isAdmin || isEditor || isTrader ">
                <router-link to="/offeringfeed/offerings"  >
                  <span><i class="fa fa-rss"></i></span> OFFERING FEED
                    <button type="submit" class="btn btn-primary my-2" >GO
                      <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                    </button>
                </router-link>
              </div>
              <div class="opn-wrap" v-if="isAdmin || isRep">
                <router-link to="/client/admin-dashboard"  >
                   <img
                    src="../../assets/img/bondlogo-grey.png"
                    class="bondlogix-logo"
                  />  
                    <button type="submit" class="btn btn-primary my-2" >GO
                      <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                    </button>
                </router-link>
              </div>
                <div class="opn-wrap">
                <router-link to="/de-minimis/de-minimis-customer-report"  >
                  <span><i class="fa fa-rss"></i></span> DE MINIMIS 
                    <button type="submit" class="btn btn-primary my-2" >GO
                      <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                    </button>
                </router-link>
              </div>

          </div>    
          <!-- <div class="row" v-if="isOperator || isTrader || isAdmin || isGuest || isEditor || isRep" >
            <div class="opn-wrap" v-if="!isGuest && (isOperator || isTrader || isAdmin || isEditor) ">
              <router-link to="/ticketsystem/importdata"  >
                <span><i class="fas fa-folder-open"></i></span> TICKETING CATALOGUE
                  <button type="submit" class="btn btn-primary my-2" >GO
                    <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                  </button>
              </router-link>
            </div>
            <div class="opn-wrap" v-if="isGuest">
              <router-link to="/ticketsystem/processed"  >
                <span><i class="fas fa-folder-open"></i></span> TICKETING CATALOGUE
                  <button type="submit" class="btn btn-primary my-2" >GO
                    <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                  </button>
              </router-link>
            </div>
            <div class="opn-wrap" v-if="isAdmin || isEditor || isTrader || isSuperAdmin">
              <router-link to="/offeringfeed/offerings"  >
                <span><i class="fa fa-rss"></i></span> OFFERING FEED
                  <button type="submit" class="btn btn-primary my-2" >GO
                    <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                  </button>
              </router-link>
            </div>
             <div class="opn-wrap" v-if="isAdmin || isRep">
              <router-link to="/client/admin-dashboard"  >
                <span><i class="fa fa-rss"></i></span> OFFERING FEED CLIENT
                  <button type="submit" class="btn btn-primary my-2" >GO
                    <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                  </button>
              </router-link>
            </div>
          </div> -->
          </div>
          <div v-if="userOrganization && userOrganization.length > 1">
          <div class="head-text">NEW EDGE</div> 
            <div class="row">
              <div class="opn-wrap">
                <router-link to="/brockerdealer/brockerdealercapitalsettings"  >
                  <span><i class="fas fa-folder-open"></i></span> COMPLIANCE
                    <button type="submit" class="btn btn-primary my-2" >GO
                      <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                    </button>
                </router-link>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div class="sbFooter">
          <p>Office: <a href="tel:1-281-398-8600">(281) 398-8600</a> | &nbsp; &nbsp; Toll Free: <a href="tel:1-866-664-4040">(866) 664-4040</a> |  &nbsp; &nbsp; Email: <a href="mailto:drl@drlgroup.net">drl@drlgroup.net</a></p>
        </div>
        <div class="loginFooter">
          <p>
    Securities offered through NewEdge Securities, LLC, member FINRA and SIPC. The DRL Group is not a subsidiary or control affiliate of NewEdge Securities, LLC. NewEdge Securities, Inc. has no affiliation to BondDesk Trading LLC or BondTrader Pro, or Tradeweb Direct, Bondpoint, TMC, Market Axess or any ECN.<br><br>
    Do not buy discount bonds based on the Yield-to-Call (YTC). Yield to call (YTC) is not indicative of total return; this yield is valid only if the security is called. Bonds may or may not be called, or be callable on multiple dates or, in other cases, called any date following the first call date, so yield to call is based on the earliest stated call date. Discounted bonds may be subject to capital gains tax. Bonds may be subject to OID (Original Issue Discount). Bonds could also be subject to the DeMinimis Rule, please consult your tax advisor for further clarification. Insured bonds are issued for timely payment of principal and interest only. Insured bonds do not cover potential market loss and are subject to the claims paying ability of the insurance company. Municipal income may be subject to state, local, and Alternative Minimum Tax (AMT) taxation. Corporate and Municipal securities are subject to gains/losses based on the level of interest rates, market conditions, and credit quality of the issuer. Non-rated (NR), With-Drawn (WR), or below investment grade bonds, and lower-rated bonds carry a greater potential risk of default and should be considered by sophisticated investors only.<br><br>
    Prices and availability may change at any time without notice. The securities described herein may not be eligible for sale in all jurisdictions or to specific categories of investors.<br><br>
    This summary is for informational purposes only and is not an offer or solicitation for the purchase or sale of any security or a recommendation or endorsement of any security or issuer. NewEdge Securities, LLC. and DRL Group make no representation about the accuracy, completeness, or timeliness of this information.<br><br>
    This report does not regard any recipient's specific investment objectives, financial situation, or needs and is based on information obtained from sources believed to be reliable. No independent verification has been made, nor is its accuracy or completeness guaranteed. Opinions expressed herein are subject to change without notice. The division, group, subsidiary, or affiliate of NewEdge Securities, LLC, is under no obligation to update or keep the information current. NewEdge Securities, LLC accepts no liability for any loss or damage of any kind arising out of the use of this report. Contact your tax advisor regarding the suitability of tax-exempt investments in your portfolio. This document is for informational purposes only and does not replace or serve as a substitute for your official monthly statement generated by NFS. Please refer to your official statement for accurate and comprehensive account details.<br><br>
    Reminder: E-mails sent through the internet are not secure. Do not use e-mail to send us personal confidential information. Do not e-mail time sensitive instructions or trade orders. This e-mail is not an official trade confirmation for transactions executed in your account. Your e-mail message is not private; it is subject to review by the firm, its officers, agents, and employees. Unless expressly stated in this e-mail, nothing in this message should be construed as a digital or electronic signature.
</p><br>

<p>
    We take protecting your data and privacy very seriously. You can revoke your consent to receive emails at any time by using the SafeUnsubscribe® link, found at the bottom of every email.
</p><br>

<p>©2026 The DRL Group. All Rights Reserved. <a href=https://www.drlgroup.net/privacy-policy/ target="_blank">Privacy Policy</a></p>

 

      </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import pingService from "@/pingService";
import authService from "@/authService";

export default {
  name: "DashboardOption",
  data() {
    return {
     isAdmin : false,
     isEditor : false,
     isTrader : false,
     isSuperAdmin : false,
     isOperator : false,
     isRep : false,
     isGuest : false,
     tenantName : null,
     isBrokerDealer : false,
     isRiskManager : false,
     userOrganization : null,
     isCapitalRiskManager : false
    };
  },
  methods: { 
    getBestRouteForAutobidder(){
      if(this.isCapitalRiskManager ){
        return "/autobidder/bids"
      }
      else if(this.isOperator || this.isTrader || this.isAdmin || this.isEditor ){
        return "/autobidder/ecns"
      }
      else{
        return "/autobidder/branchcapitalsettings"
      }
    },
    getBestRouteForBidSide(){
      if(this.isAdmin){
        return "/bidside/admin-dashboard";
      }
      if(this.isSuperAdmin && !this.isAdmin && !this.isEditor && !this.isTrader){
        return "/bidside/admin-users";
      }
      if(this.isSuperAdmin && this.isTrader && !this.isAdmin && !this.isEditor){
        return "/bidside/trader-dashboard";
      }
      if(this.isTrader && !this.isAdmin && !this.isEditor && !this.isSuperAdmin){
        return "/bidside/trader-dashboard";
      }
      if(this.isEditor && !this.isAdmin && !this.isTrader && !this.isSuperAdmin){
        return "/bidside/admin-managecusips";
      }
      if(this.isEditor && !this.isAdmin && this.isTrader && !this.isSuperAdmin){
        return "/bidside/trader-dashboard";
      }
      if(this.isSuperAdmin){
        return "/bidside/admin-users";
      }
      if(this.isEditor){
        return "/bidside/admin-managecusips";
      }
    //return redirectUrl;
    },
    getBestRouteForIms(){
      //to="/ims/ims-dashboard"
       if(this.isSuperAdmin && !this.isAdmin && !this.isEditor && !this.isTrader){
        return "/ims/admin-users";
      }
      return "/ims/ims-dashboard";
    }
  },
  created() {
     this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          this.tenantName = role[0].split("-")[0];

          var roleArray = role.map(item => {return  item.split("-")[1]})
              roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
              roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
              roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
              roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
              roleArray.includes('Operator')  ? this.isOperator = true : this.isOperator = false;
              roleArray.includes('Guest')  ? this.isGuest = true : this.isGuest = false;
              roleArray.includes('RiskManager')  ? this.isRiskManager = true : this.isRiskManager = false;
              roleArray.includes('Rep')  ? this.isRep = true : this.isRep = false;
              roleArray.includes('CapitalRiskManager')  ? this.isCapitalRiskManager = true : this.isCapitalRiskManager = false;
        
              this.tenantName.toLowerCase() === "newedge" ? this.isBrokerDealer = true : this.isBrokerDealer = false;
              console.log("Roles from token", this.isBrokerDealer);
        }
      });
      this.$cognitoAuth.getUserRoles((err,userRoles) => {
        if (err) {
          console.log("Session not found. Can't access roles", err);
        } else {
          console.log("myroles",userRoles)
        }
      })
      this.userOrganization = authService.getUserOrganization();
      

      //Ping
      if(localStorage.getItem("userLastSeen")){
         const unixTimestamp = Number(localStorage.getItem("userLastSeen"));
         const momentDate = this.moment(unixTimestamp);
         const currentMoment = this.moment();
         const timeDifference = currentMoment - momentDate;
         const sessionTimeout = 5 * 1000; // 5 seconds
         // Check if the time difference is greater than session time
         if (timeDifference > sessionTimeout) {
            //this.$alert("Your current session has been expired.","","error");
            pingService.stopTimer();
            this.$root.$emit("logout");
            this.$cognitoAuth.logout();
            this.$router.push({ path: "/" });
            console.log("ForceFull logout during ping check from dashboardOption Page")

         } else {
            //alert('');
         }
      }
    pingService.startTimer();
  }
};
</script>
<style scoped>
.bondlogix-logo {
  width: 75%;
  height: auto;
  margin-bottom: 0px;
  margin-right: 30px;
}
</style>

